import React from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { GuestUserJoinNowModal } from "components/GuestUserJoin/GuestUserJoinNowModal";
import { useAuth } from "context/auth-context";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import {
  checkAndupdateSurveyStatusApi,
  checkUserProfileStatusApi,
} from "./../../api/comman/SurveyRedirectApi";
import { ZAMPLIA_SURVEYS_VENDOR__ID } from "../../config/constants";
import QuataFull from "../../assets/completeSurvey/quota.png";
export const Quotafull = () => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const [searchParams] = useSearchParams();
  const [uid, setUid] = React.useState("");
  const [sid, setSid] = React.useState("");
  const [vid, setVid] = React.useState("");
  const [sessionId, setSessionId] = React.useState("");
  const [isHmacFailed, SetHmacFailed] = React.useState(false);
  const [currentUrl, setCurrentUrl] = React.useState("");
  const [hmacValue, setHmacValue] = React.useState("");
  const [isShowGuestUserPopUP, setShowGuestUserPopUP] = React.useState(false);

  useQuery(
    ["checkAndupdateSurveyStatus"],
    () => checkAndupdateSurveyStatusApi(auth?.panelistId, sid, vid, hmacValue, currentUrl, sessionId),
    {
      enabled: !!uid,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        if (response?.isHamcFailed) {
          SetHmacFailed(true);
        }
      },
    }
  );

  useQuery(
    ["getUserProfileStatusQuotaFull"],
    () => checkUserProfileStatusApi(uid),
    {
      enabled: !!uid,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        if (response.success && response.data.length > 0) {
          setShowGuestUserPopUP(true);
        }
      },
    }
  );

  React.useEffect(() => {
    const hmac = searchParams.get("hmac");
    const UID = searchParams.get("UID");
    const SID = searchParams.get("SID");
    const SESSION_ID = searchParams.get("SESSION_ID");
    const VID = ZAMPLIA_SURVEYS_VENDOR__ID;
    if (UID && SID && VID) {
      setUid(UID);
      setSid(SID);
      setVid(VID);
      setSessionId(SESSION_ID);
      setCurrentUrl(`${window.location.origin}${window.location.pathname}?SID=${SID}&UID=${UID}&SESSION_ID=${SESSION_ID}`);
      if (hmac) setHmacValue(hmac);
    }
  }, []);

  return (
    <LoadingOverlay active={isShowGuestUserPopUP} spinner text={t("claim.card.Loading")}>
     <div className="w-[95vw] flex justify-center items-center">
        <div className="flex flex-col items-center justify-center min-h-screen px-4 ">
        <div className="max-w-md px-10 py-20 text-center bg-white rounded-3xl  text-[#434343]">
          <img src={QuataFull} alt="Success" className="w-32 mx-auto" />
          <h2 className="m-6 text-3xl font-semibold text-gray-800">
            {isHmacFailed ? t("page.surveysecurityterminate.internal") : t("page.quotafull.SurveyHave")}
          </h2>
          <p className="mb-4 text-gray-600">
            {t("page.terminate.Explore")}
          </p>
          <p className="mb-6 text-sm italic text-gray-500">
            {t("page.terminate.case")}
          </p>
          <a href="/join-now" className="px-10 py-3 mt-6 text-lg font-medium text-white transition bg-[#056E9C] rounded-full">
            {t("page.quotafull.MySurveys")}
          </a>
        </div>
        {isShowGuestUserPopUP && (
          <GuestUserJoinNowModal show={isShowGuestUserPopUP} hideGuestUserPopup={() => setShowGuestUserPopUP(false)} uid={uid} />
        )}
      </div>
      </div>
    </LoadingOverlay>
  );
};
